export default __webpack_public_path__ + "static/media/bajookieland-bomb.059e4098.jpg";